import React from 'react';
import { TaggingFieldWithLabel } from '@adjust/dashboard-components';
import { connectWithStore } from '@react/Common/connectWithStore';
import { getUserPermissionsState, updateTrackerKeywords } from '@redux/ducks/userPermissions/userPermissions';
import { TrackerRole } from '@redux/ducks/userPermissions/utils';

const keywordSize = value => value.length < 4 || value.length >= 256;

const UpdateKeywordsComponent = ({ currentTracker, onChange }) =>
  currentTracker && TrackerRole[currentTracker.access?.role] === TrackerRole.custom ? (
    <div className="form-row">
      <label>{t('field.keyword-pattern')}</label>
      <TaggingFieldWithLabel
        placeholder={t('label.type-keywords')}
        name="keywords"
        value={currentTracker.access.keywords}
        onChange={onChange}
        validation={keywordSize}
      />
      <span className="info">{t('field.keyword-pattern.instructions')}</span>
    </div>
  ) : null;

const mapStateToProps = state => {
  const { currentTracker } = getUserPermissionsState(state);

  return { currentTracker };
};

const mapStateToDispatch = {
  onChange: updateTrackerKeywords,
};

export const UpdateKeywords = connectWithStore(mapStateToProps, mapStateToDispatch)(UpdateKeywordsComponent);
